import { SettingsRoutes } from 'pages/settings'
import { ReferralsRoutes } from './type'

const referrals = `${ReferralsRoutes.root}`
const referralsFull = `${SettingsRoutes.organization}/${referrals}`

export const ReferralsPath = {
  root: referralsFull,
}
